import { ToastViewport, useToasts, type ToastTone } from '@bennows/boows-react';
import { createContext, useContext, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Push = (message: ReactNode, tone?: ToastTone) => void;

const ToastContext = createContext<Push>(() => undefined);

/** One toast viewport for the console (style guide 2.4: success feedback is a toast). */
export function ToastProvider({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { toasts, push, dismiss } = useToasts();
  return (
    <ToastContext.Provider value={(message, tone = 'success') => void push(message, tone)}>
      {children}
      <ToastViewport toasts={toasts} onDismiss={dismiss} closeLabel={t('common.close')} />
    </ToastContext.Provider>
  );
}

export function useToast(): Push {
  return useContext(ToastContext);
}
